import type { WizardActionButtonProps } from "../WizardContext";

export type WizardSecondaryButtonPlacement = "bottomBar" | "topBarOnMobile";

export interface WizardSecondaryButtonProps extends WizardActionButtonProps {
  /** Where to render on mobile. Default `bottomBar` — sits in the bottom action dock.
   *  `topBarOnMobile` moves the button into the top-right cluster on mobile only. */
  placement?: WizardSecondaryButtonPlacement;
}

/** Marker slot — Wizard reads props from this element rather than rendering it. */
export function WizardSecondaryButton(_props: WizardSecondaryButtonProps) {
  return null;
}
